import React from 'react';
export function ToolsSection() {
  return <section data-id="element-4344">
      <div className="bg-[#026ab7] py-4 px-6 rounded-t-xl" data-id="element-4345">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-4346">
          Tools for High Speed Machining
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-4347">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-4348">
          <div className="space-y-2" data-id="element-4349">
            <h3 className="text-xl font-bold text-navy" data-id="element-4350">Use Dedicated Tools</h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-4351">
              - It is important to have dedicated roughing and finishing tools
              in order to reduce tool wear between separate operations.
            </p>
          </div>
          <div className="space-y-2" data-id="element-4352">
            <h3 className="text-xl font-bold text-navy" data-id="element-4353">Keep Tooling Short</h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-4354">
              - Machine tools are pushed to their limits for HSM. In order to
              obtain high accuracy, repeatability, and surface finish, fixtures
              and tools must be absolutely rigid to withstand the high loads
              associated with the process.
            </p>
          </div>
          <div className="space-y-2" data-id="element-4355">
            <h3 className="text-xl font-bold text-navy" data-id="element-4356">Balanced Tooling</h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-4357">
              - Tool balance is important when running at high RPMs. Most common
              tool designs with tool holders will work without a noticeable
              problem at speeds less than 7,000 to 8,000 RPM. But, at higher
              speeds, you can start to see runout problems and decreased tool
              life.{' '}
              <strong data-id="element-4358">
                Shrink fit tooling is essential in order to maintain balance at
                high RPM.
              </strong>
            </p>
          </div>
          <div className="space-y-2" data-id="element-4359">
            <h3 className="text-xl font-bold text-navy" data-id="element-4360">A Clean Process</h3>
            <p className="text-gray-700 leading-relaxed" data-id="element-4361">
              - High Speed Milling generates chips faster than conventional
              milling. Use oil mist/air blast, or coolant (when necessary) in
              order to clear chips away to an appropriate chip management
              solution.
            </p>
          </div>
        </div>
      </div>
    </section>;
}